<template>
  <div class="animated fadeIn list-of-koran_report">
    <b-card>
      <div slot="header">
        REKENING KORAN AGEN 
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="print()">
            <i class="fa fa-print"></i> Print
          </button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>
            Export
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-row>
        <b-col md="6" xl="4">
          <b-input-group>
            <b-input-group-prepend>
              <span class="pt-2 pr-2">AGEN</span>
            </b-input-group-prepend>
            <b-form-input readonly               
            v-model="tblData.custinfo"
              @keyup.13.native="lkuKoranCustShow=true"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuCustomerShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
            <b-input-group-append>
              <b-btn text="Button" @click="clearCustomer" class="ml-1">
                <i class="fa fa-close"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col md="6" xl="4">
          <b-input-group>
            <b-input-group-prepend>
              <span class="pt-2 pr-2">sd Periode</span>
            </b-input-group-prepend>
            <b-form-input
              v-model="tblData.tgl2"
              type="date"
              placeholder="until date"
              :state="!$v.tblData.tgl2.$error"
            ></b-form-input>
            <b-button class="btn btn-success ml-2" @click="getData()">
              <i class="fa fa-play"></i> View
            </b-button>
          </b-input-group>
        </b-col>
      </b-row>

      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        striped
        hover
        style="font-size:smaller;"
        :items="rptLines"
        :fields="tblFields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc" 
          :key="tblData.page"
          :filter="filter"
          :filterIncludedFields="filterOn"
          @filtered="onFiltered"                
      >
        <template v-slot:cell(tanggal)="data">{{ data.item.tanggal | moment("DD MMM YYYY") }}</template>        
        <template v-slot:cell(eksemplar)="data">
          <span v-if="(data.item.eksemplar)">{{ data.item.eksemplar | numFormat }}</span> 
       </template>
        <template v-slot:cell(debet)="data">
          <span v-if="(data.item.debet)">{{ data.item.debet | numFormat }}</span> 
       </template>
        <template v-slot:cell(kredit)="data">
          <span v-if="(data.item.kredit)">{{ data.item.kredit | numFormat }}</span> 
        </template> 
        <template v-slot:cell(saldo)="data">{{ data.item.saldo | numFormat }}

        </template>
      </b-table>
      <b-row>
        <b-col cols="5">
            <b-input-group >
              <b-input-group-prepend><span class=" pt-1 mr-1" >Filter</span></b-input-group-prepend>
              <b-form-select :options="filterOnChoices" :plain="true" v-model="tblData.filterOn" />
              <b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to filter" style="width:50% !important;"></b-form-input>
              <b-input-group-append><b-button :disabled="!filter" @click="filter=''">Clear</b-button></b-input-group-append>
            </b-input-group>
        </b-col>
        <b-col cols="4">
          <b-row>
            <b-col cols="7">
                <div>
                  Total {{tblData.total}} records,
                  <span class="ml-1">per page :</span>
                <input type="number" style="width:60px;" v-model="tblData.limit" v-b-tooltip.hover :title="`${tblData.limit} records`" />
                </div>
            </b-col>
            <b-col cols="5">
              <b-pagination
                align="left"
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="3" >
          <b-input-group>
                <b-input-group-prepend><span class="input-group-text">Saldo Piutang</span></b-input-group-prepend>              
                <b-form-input :value="tblData.saldototal | numFormat('0,0.00')" readonly class="text-right font-weight-bold"></b-form-input>
                <b-input-group-prepend><span class="input-group-text">{{user.uanguser}}</span></b-input-group-prepend>              
          </b-input-group>
        </b-col>        
      </b-row>


    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal
      v-model="lkuCustomerShow"
      size="lg"
      :hide-footer="true"
      title="List of Customer"
      :centered="true"
    >
      <lku-customer @click="onSelectLkuCustomer" customer_group='KORAN' bill2group="'0'"></lku-customer>
    </b-modal>
  </div>
</template>



<script>
import moment from "moment";
import koran_report from "../../apis/koran_report";
import lkuCustomer from "../lookup/lkuKoranCust";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    tblData: {
      tgl2: { required }
    }
  },
  data() {
    return {
      horizontal: true,
      isLoading: false,
      showReport: false,
      lkuCustomerShow: false,
      reportUrl: `${location.origin}/#load`,
      currency: [],
      rptLines: [],
      subtotal: { debit: 0, credit: 0, outstand: 0 },
      user: this.$store.state.user,
      showFilter: false,
      filter: null,
      filterOn: [],
      filterOnChoices:[{value:'', text:'All Columns'},{value:'jenistrx', text:'Jenis Trx'}, {value:'uraian', text:'Keterangan'},{value:'CustName', text:'Nama Agen'},],
      tblData: {
        customer_id:'',alltrx:0,
        tgl2: '',
        filterOn:'',
        page: 1,
        limit: 20,
        total: 0,
        periode1: moment(this.$store.state.user.tglkoran,'YYYY-MM-DD'),
        sortBy: 'CustName', prosesulang:0, 
        sortDesc: false
      },
      tblFields: [
        {
          key: "tanggal",
          label: "Tanggal",
          thStyle: "width:110px",
        },
        {
          key: "nomor",
          label: "No.Transaksi",
          thStyle: "width:150px",
        },
        {
          key: "jenistrx",
          label: "Jenis Transaksi",
          thStyle: "width:150px",
          sortable: true
        },
        {
          key: "uraian",
          label: "Keterangan"
        },
        {
          key: "eksemplar",
          label: "Eksemplar",
          thStyle: "width:50px",
          thClass: "text-center",
          tdClass: "text-center"
        },
       {
          key: "debet",
          label: "DEBET",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-right",
          variant: "primary",
          sortable: true
        },
        {
          key: "kredit",
          label: "KREDIT",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-right",
          variant: "danger",
          sortable: true
        },
        {
          key: "saldo",
          label: "SALDO",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-right",
          variant: "success",
        },
      ]
      
    };
  },
  components: { Loading, lkuCustomer },
  computed: {
    invalidFilter() {
      this.$v.tblData.$touch();
      return this.$v.tblData.$invalid;
    }
  },
  created: async function() {
    try {
      const tgl2 = moment(this.$store.state.user.tglaktif, "YYYY-MM-DD")
        .add(1, "M")
        .subtract(1, "day");
      // this.tblData.tgl1=this.$store.state.user.tglaktif;
      this.tblData.tgl2 = tgl2.format("YYYY-MM-DD");

      this.$watch('tblData.filterOn', function(newVal) {
        console.log('selecteted filte On: ', newVal);
        this.filterOn=[];
        if (newVal) {
          this.filterOn.push(newVal);
        }
      });            

    } catch (error) {
      console.log("error", error);
    }
  },
  methods: {
    onSelectLkuCustomer: async function(_selected) {
      this.tblData.custinfo =
        _selected.CustCode.trim() + " | " + _selected.CustName.trim();
      this.tblData.CustCode = _selected.CustCode;
      this.tblData.CustName = _selected.CustName;
      this.tblData.customer_id = _selected.customer_id;
      this.lkuCustomerShow = false;
    },
    clearCustomer: function(){
      this.tblData.custinfo ='';
      this.tblData.CustCode = '';
      this.tblData.CustName = '';
      this.tblData.customer_id = '';
      this.lkuCustomerShow = false;

    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },
    getData: async function(ctx) {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
          this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
          if (!(this.tblData.customer_id)) {
              toastr.error('Tampilan pada VIEW hanya untuk satu AGEN, silahkan pilih AGEN terlebih dulu','ERROR MESSAGE',10000);
              return;
          }
          this.isLoading=true;
          const list = await koran_report.trxrekening(this.tblData);
            // this.tblData.saldototal = list.reduce((a, b) => a + b.saldo, 0);
          if (list.length>0) {
            this.tblData.saldototal = list[list.length-1].saldo;
          }
          this.tblData.total = list.length;
          this.isLoading=false;
          this.rptLines= list;
          // return list;
      }
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    print: async function() {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          this.reportUrl = await koran_report.trxrekeningprint(this.tblData);
          this.isLoading = false;
          this.showReport = true;
        } catch (error) {
              this.isLoading = false;
              console.log('error : ', error);
              if (error.sql) {
                  toastr.error(error.sql,'ERROR MESSAGE',10000);
              } else if (error.sqlMessage) {
                  toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
              } else if (error.message) {
                  toastr.error(error.message,'ERROR MESSAGE',10000);
              } else {
                  toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
              }   
        }
      }
    },
    exportxls: async function() {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          const response = await koran_report.trxrekeningexport(this.tblData);
          this.isLoading = false;
        } catch (error) {
              this.isLoading = false;
              console.log('error : ', error);
              if (error.sql) {
                  toastr.error(error.sql,'ERROR MESSAGE',10000);
              } else if (error.sqlMessage) {
                  toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
              } else if (error.message) {
                  toastr.error(error.message,'ERROR MESSAGE',10000);
              } else {
                  toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
              }   
        }
      }
    },
    close() {
      router.push({name: "koran.home"});
    }
  }
};
</script>
